window.addEventListener('turbolinks:load', () => {
  var redirectElement = document.querySelector(".js-redirect")

  if (redirectElement) {
    const url = redirectElement.dataset.url
    document.location = url
  }
})